

export const resetDeleteWorkersReducer = (state) => {
    state.deleteWorkers.status = "idle";
    state.deleteWorkers.errorMessage = "";
  }
